/**
 * Default Trusted Types script-URL allowlist.
 *
 * Each entry may include a path prefix (e.g. `gstatic.com/firebasejs`); see
 * `trusted-types-setup.ts` for matching rules.
 *
 * The current `window.location.hostname` is appended at runtime — this file
 * lists only third-party hosts.
 *
 * Air-gap builds replace this file via `project.json` `fileReplacements`.
 */
export const TRUSTED_TYPES_SCRIPT_URL_ALLOWLIST: ReadonlyArray<string> = [
  'stonly.com',
  'maps.googleapis.com',
  'gstatic.com/firebasejs',
  'usersnap.com',
];
